export type LangKey = keyof typeof langAbbrev;

export const langAbbrev = {
  en: 'EN',
  de: 'DE',
  es: 'ES',
  fr: 'FR',
  it: 'IT',
  cn: '中文',
  jp: '日本語',
  ko: '한국어',
  pt: 'PT',
  ukr: 'УКР',
  dk: 'DK',
  nl: 'NL',
  pl: 'PL',
  swe: 'SV',
  nor: 'NO',
  fin: 'FI',
  hun: 'HU',
  
}
export const langLabels = {
  en: 'English',
  de: 'German',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  cn: 'Chinese',
  jp: 'Japanese',
  ko: 'Korean',
  pt: 'Portuguese',
  ukr: 'Ukrainian',
  dk: 'Danish',
  nl: 'Dutch',
  pl: 'Polish',
  swe: 'Swedish',
  nor: 'Norwegian',
  fin: 'Finnish',
  hun: 'Hungarian',
}
